import { createSlice } from '@reduxjs/toolkit';
import PackageService from 'services/PackageService';

const initialState = {
  data: [],
};

const wizardsSlice = createSlice({
  name: 'wizards',
  initialState,
  reducers: {
    setWizards(state, action) {
      state.data = action.payload;
    },
  },
});

export const { setWizards } = wizardsSlice.actions;

export const initializeWizards = () => {
  return async (dispatch) => {
    try {
      const { data } = await PackageService.getAllWizards();
      const transformedData = data.map((wizard) => ({
        ...wizard,
        value: wizard.title,
        name: wizard.title,
      }));
      dispatch(setWizards(transformedData));
    } catch (error) {
      console.error(error);
    }
  };
};

export default wizardsSlice.reducer;
